import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function FDHero() {
  return <section className="relative pt-[120px] pb-[60px] lg:pt-[160px] lg:pb-[100px] overflow-hidden min-h-[500px] lg:min-h-[70vh] flex items-center" data-id="element-1111">
      {/* Background Image */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/kT31Zrmcrn9CBAq9mYrN1Q/Fat-dissolving-Injections.jpg)'
    }} data-id="element-1112" />
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/60" data-id="element-1113" />

      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 w-full relative z-10" data-id="element-1114">
        <AnimateOnScroll className="w-full lg:w-[60%]" data-id="element-1115">
          <div className="mb-6" data-id="element-1116">
            <span className="text-[#999999] text-[13px] font-body" data-id="element-1117">
              <a href="/treatments" className="hover:text-[#FF1493] transition-colors" data-id="element-1118">
                Treatments
              </a>{' '}
              / Injectables
            </span>
          </div>

          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-1119">
            Be CONFIDENT
          </span>

          <h1 className="text-[30px] sm:text-5xl lg:text-[56px] uppercase text-white tracking-tight mb-6 font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-1120">
            FAT DISSOLVING INJECTIONS
          </h1>

          <div className="space-y-6" data-id="element-1121">
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body italic" data-id="element-1122">
              "Stubborn fat can be a real confidence killer. Whether it's making
              your clothes fit awkwardly or leaving you self-conscious without
              them, those fatty deposits are frustrating to deal with," says Dr.
              Fiona Frie.
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-1123">
              As we age, our bodies start playing by different rules—hormones
              shift, metabolism slows, and fat seems to set up camp in all the
              wrong places. It's not your fault, but the good news is, with help
              from Be CLINICAL, you don't have to settle for it.
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-1124">
              Fat-dissolving injections like Kybella and our proprietary
              injectable, BeSCULPTED, are simple, effective ways to target and
              eliminate those problem areas, so you can stop stressing and start
              loving how you look again.
            </p>
          </div>

          <Button variant="primary" size="lg" className="mt-8 w-full sm:w-auto" data-id="element-1125">
            SCHEDULE CONSULTATION
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}